import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/images/Mantain-ease-min.png"

const Maintainease = () => {
  return (
    <>
     <div className="home-container">
      <Sidebar/>
      <div className="home-content">
        <img
          src={image} 
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
    </>
  )
}

export default Maintainease